import LaunchDarkly from '@module/launchdarkly';
import { FF_COOKIE_WALL } from '@app/constant/experiments';

import { isValidTCString } from '@module/consent-manager/tc-model';

export function isConsentFlagActive() {
  return LaunchDarkly.getVariant(FF_COOKIE_WALL);
}

// This fn used to be called shouldDisplayCookieWall but in the future, there
// might be a panel instead of a wall.
export function isConsentActivated({ user, session, consent }) {
  if (!user || !session) {
    return true;
  }

  if (isConsentFlagActive() && !isValidTCString(consent?.tcString)) {
    return true;
  }

  return consent?.uiVisible;
}
